import React, { useEffect } from "react";
import JobZImage from "../../../../common/jobz-img";
import moment from "moment";
import { useSelector } from "react-redux";
import Avatar from "../../../../common/chat-avatar-by-name";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import SectionCanChatPopup from "./section-can-chat-popup";
import {doc, setDoc, updateDoc, getDoc } from 'firebase/firestore';
import { db } from "../../../../common/firebase/firebase";

const ActiveColor={backgroundColor:'#eee'}
function SectionCanChatList({jobId,chatList, handleSelectionChat,setIsJobList,isJobList,setSearchValue,searchValue,getAllChats, setIsGroupChat, adminDetails, isGroup}) {

  const { id } = useParams();
    const { isLoggedIn, userInfo, role_type } = useSelector(
        (state) => state.menu
      );
      // const isAdmin = userInfo?.roleEntities[0]?.roleType=="ROLE_OPENSTAFF_ADMIN"
    const adminRoles = [
      "ROLE_OPENSTAFF_ADMIN",
      "ROLE_SEEKER_USER_ADMIN",
      "ROLE_INSTITUTION_POSTER_ADMIN",
      "ROLE_OPENSTAFF_FINANCIAL_ADMIN"
    ];

    const userRoleType = userInfo?.roleEntities?.[0]?.roleType;
    const isAdmin = adminRoles?.includes(userRoleType);
    
    const formatDate = (date) => {
      const now = moment();
      const chatDate = moment(date);
    
      if (chatDate.isSame(now, 'day')) {
        return chatDate.format('HH:mm');
      } else if (chatDate.isSame(now.subtract(1, 'day'), 'day')) {
        return 'Yesterday';
      } else {
        return chatDate.format('MM/DD/YYYY');
      }
    };
    const navigate = useNavigate();
    
    const handleSelectionChatNav = (chat) => {
      handleSelectionChat(chat?.jobId, chat?.groupId ? true : false)
      // if(chat?.groupId){
      //   setIsGroupChat(true);
      //   // navigate(`/chats/${chat?.jobId}?isGroup=true`);
      // }else{
      //   setIsGroupChat(false)
      // }
        navigate(`/chats/${chat?.jobId}`);
    };

    const handleStartChat = async (jobId) => {
      try {
        const currentDateInSeconds = Math.floor(new Date().getTime() / 1000);
    
        const userDetails = {
          id: userInfo?.id,
          email: userInfo?.email,
          firstName: userInfo?.firstName,
          lastName: userInfo?.lastName,
          roleType: userInfo?.roleEntities[0]?.roleType,
        };
    
        const receiverDetails = {
          id: adminDetails?.roleEntities[0]?.id,
          email: adminDetails?.email,
          firstName: adminDetails?.firstName,
          lastName: adminDetails?.lastName,
          roleType: adminDetails?.roleEntities[0]?.roleType,
        };
    
        const docRef = doc(db, "groupChats", jobId);
        const docSnap = await getDoc(docRef);
    
        if (docSnap.exists()) {
          const groupData = docSnap.data();
          const existingMembers = groupData.members || [];
          let isMemberExist = false;
    
          // Check if the new member is already in the group
          if (existingMembers.some((member) => member?.id === userInfo?.id)) {
            isMemberExist = true;
          }
    
          // Add new member
          await updateDoc(docRef, {
            message: [...groupData.message],
            members: isMemberExist
              ? existingMembers
              : [...existingMembers, userDetails],
            modifiedOn: new Date(),
          });
        } else {
          let chatObj = {
            receiverId:  adminDetails?.roleEntities[0]?.id || "unknown",
            receiverEmail: adminDetails?.email || "unknown",
            receiverFirstName: "Admin" || "unknown",
            groupId: jobId || "unknown",
            groupName: "Admin",
            members: [userDetails, receiverDetails],
            createdBy: userInfo?.id,
            createdOn: new Date(),
          };
    
          await setDoc(docRef, {
            message: [],
            jobId: jobId || "unknown",
            // jobTitle: jobItem?.jobTitle|| 'unknown',
            senderId: userInfo?.id || "unknown",
            senderEmail: userInfo?.email || "unknown",
            senderFirstname: userInfo?.firstName || "unknown",
            senderLastname: userInfo?.lastName || "unknown",
            startedOn: new Date(),
            _id: userInfo?.id + currentDateInSeconds,
            modifiedOn: new Date(),
            ...chatObj,
          });
          getAllChats();
        }
      } catch (error) {
        console.log("chat error---", error);
      }
    };
    

    const handleAdminChat =async (job_id) => {
      await handleStartChat(job_id);
      handleSelectionChat(job_id, true)
    }

    useEffect(() => {
      console.log("id:::::", id)
      handleSelectionChat(id);
    }, [])
    return (
      <>
        <div className="wt-dashboard-msg-user-list" style={{ width: "100%" }}>
          <div className="user-msg-list-btn-outer">
            <button className="user-msg-list-btn-close">Close</button>
            <button className="user-msg-list-btn-open">User Message</button>
          </div>

          {/* Search Section Start*/}

          <div className="wt-dashboard-msg-search">
            {!isAdmin&&
          <div className="d-flex" style={{ justifyContent: 'space-between', alignItems: 'center'}}>
            {/* <a
              className="site-button button-sm"
              href={"#can-admin-chat-popup"}
              data-bs-toggle="modal"
              role="button"
              style={{ height : "10px" }}
              >
               Admin Chat
             </a> */}
             {
              (role_type.includes('ROLE_USER') || role_type.includes('ROLE_INSTITUTION_ADMIN') )&&
              <button className="site-button button-sm my-3" onClick={()=> handleAdminChat(role_type.includes('ROLE_INSTITUTION_ADMIN') ? userInfo?.institutionId : userInfo?.id)}>
                <i class="fa fa-headset"></i> Contact Support 
              </button>
             }
             
            <button className="site-button button-sm my-3 float-right" onClick={()=>setIsJobList(!isJobList)}>
            {isJobList?(<>
            <i className="fa fa-times" />
            Close
            </> )
            :
            (<>
             <i className="fa fa-plus" />
             New Chat
                </> )
          }
          </button>
         
            
            </div>
          }
            <div className="input-group">
              <input
                className="form-control"
                placeholder="Search Messages"
                type="text"
                value={searchValue}
                onChange={(e)=>setSearchValue(e.target.value)}
              />
              {searchValue?
              <button className="btn" type="button" onClick={()=>setSearchValue('')}>
                <i className="fa fa-times" />
              </button>
             :<button className="btn" type="button" onClick={getAllChats}>
             <i className="fa fa-search" />
           </button>}
              
            </div>
          </div>
          {/* Search Section End*/}
          {/* Search Section End*/}
          <div className="msg-find-list">
            <select className="wt-select-box bs-select-hidden">
              <option>Recent Chats</option>
              <option>Short by Time</option>
              <option>Short by Unread</option>
            </select>
          </div>
          {/* Search Section End*/}
          {/* user msg list start*/}
          <div
            id="msg-list-wrap"
            className="wt-dashboard-msg-search-list scrollbar-macosx active"
          >
            {chatList?.length > 0 ? (
              chatList?.map((chat) => {
                let senderName = {
                  firstName: "",
                  lastName: "",
                  fullName: "",
                };
                if (isAdmin) {
                  senderName = {
                    ...senderName,
                    fullName:
                      chat?.senderFirstname +
                      " " +
                      chat?.senderLastname || "" +
                      ", " +
                      chat?.receiverFirstName +
                      " " +
                      chat?.receiverLastName || "",
                  };
                }else if (chat?.groupId) {
                  senderName = {
                    ...senderName,
                    firstName: chat?.groupName,
                    lastName: ""
                  };
                }  else if (userInfo?.id == chat?.senderId) {
                  senderName = {
                    ...senderName,
                    firstName: chat?.receiverFirstName,
                    lastName: chat?.receiverLastName,
                  };
                } else if (userInfo?.id == chat?.receiverId) {
                  senderName = {
                    ...senderName,
                    firstName: chat?.senderFirstname,
                    lastName: chat?.senderLastname,
                  };
                }
                // let latestDate = getLatestMessageDate(chat?.message);
                // console.log("latestDate::::::::::::::::", latestDate);
                return (
                  <div
                    className="wt-dashboard-msg-search-list-wrap"
                    
                    onClick={() => handleSelectionChatNav(chat)}
                  >
                    {/* {console.log("chat?.jobId==jobId===", chat?.jobId, jobId)} */}
                    <NavLink className="msg-user-info clearfix" style={chat?.jobId==jobId?ActiveColor:{}}>
                      <div className="msg-user-timing">
                        {formatDate(new Date(chat?.modifiedOn?.toDate()))}
                      </div>
                      <div
                        style={{ display: "flex" }}
                      >
                        <div className="my-10">
                          <Avatar
                            firstName={senderName?.firstName}
                            lastName={senderName?.lastName}
                            isAdmin={isAdmin}
                          />{" "}
                        </div>
                        <div className="msg-user-info-text">
                          <div className="msg-user-name">
                            {isAdmin 
                              ? chat?.groupId && chat?.jobTitle ? chat?.groupName :senderName?.fullName
                              : senderName?.firstName +
                                " " +
                                senderName?.lastName}
                          </div>
                          {
                            !chat?.groupId && 
                            <div className="msg-user-discription">
                              {chat?.jobTitle}
                            </div>
                          }
                          {
                            chat?.groupId && chat?.members?.length > 0 && !role_type?.includes("ROLE_USER") &&
                            <div className="msg-user-discription">
                              {chat?.groupName != 'Admin' && ((chat?.members?.find(user => user?.roleType === 'ROLE_USER')?.firstName) || "") + " " + ((chat?.members?.find(user => user?.roleType === 'ROLE_USER')?.lastName) || "")}
                            </div>
                          }
                         
                        </div>
                      </div>
                    </NavLink>
                  </div>
                );
              })
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100vh", // Make the container take the full height of the viewport
                  textAlign: "center",
                }}
              >
                no chat in list
              </div>
            )}

            {/* <div className="wt-dashboard-msg-search-list-wrap">
                        <a href="#" className="msg-user-info clearfix">
                            <div className="msg-user-timing">16/07/2023</div>
                            <div className="msg-user-info-pic"><JobZImage src="images/user-avtar/pic2.jpg" alt="" /></div>
                            <div className="msg-user-info-text">
                                <div className="msg-user-name">Christina Fischer </div>
                                <div className="msg-user-discription">All created by our Global</div>
                            </div>
                        </a>
                    </div>
                    <div className="wt-dashboard-msg-search-list-wrap">
                        <a href="#" className="msg-user-info clearfix">
                            <div className="msg-user-timing">16/07/2023</div>
                            <div className="msg-user-info-pic"><JobZImage src="images/user-avtar/pic3.jpg" alt="" /></div>
                            <div className="msg-user-info-text">
                                <div className="msg-user-name">Wanda Willis</div>
                                <div className="msg-user-discription">All created by our Global</div>
                            </div>
                        </a>
                    </div>
                    <div className="wt-dashboard-msg-search-list-wrap">
                        <a href="#" className="msg-user-info clearfix">
                            <div className="msg-user-timing">16/07/2023</div>
                            <div className="msg-user-info-pic"><JobZImage src="images/user-avtar/pic4.jpg" alt="" /></div>
                            <div className="msg-user-info-text">
                                <div className="msg-user-name">Peter Hawkins</div>
                                <div className="msg-user-discription">All created by our Global</div>
                            </div>
                        </a>
                    </div>
                    <div className="wt-dashboard-msg-search-list-wrap">
                        <a href="#" className="msg-user-info clearfix">
                            <div className="msg-user-timing">16/07/2023</div>
                            <div className="msg-user-info-pic"><JobZImage src="images/user-avtar/pic1.jpg" alt="" /></div>
                            <div className="msg-user-info-text">
                                <div className="msg-user-name">Kathleen Moreno</div>
                                <div className="msg-user-discription">All created by our Global</div>
                            </div>
                        </a>
                    </div>
                    <div className="wt-dashboard-msg-search-list-wrap">
                        <a href="#" className="msg-user-info clearfix">
                            <div className="msg-user-timing">16/07/2023</div>
                            <div className="msg-user-info-pic"><JobZImage src="images/user-avtar/pic2.jpg" alt="" /></div>
                            <div className="msg-user-info-text">
                                <div className="msg-user-name">Wanda Montgomery </div>
                                <div className="msg-user-discription">All created by our Global</div>
                            </div>
                        </a>
                    </div> */}
          </div>
          {/* user msg list End*/}
          {/* <SectionCanChatPopup userInfo={userInfo}/> */}
        </div>
      </>
    );
}
export default SectionCanChatList;